import { patientFindingsQueryOptions } from '@app/icare/entities/patient/queries/patientFindingsQueryOptions'
import type { PatientIdType } from '@app/icare/entities/patient/schema/Patient'
import type { PatientFindingView } from '@app/icare/entities/patientFinding/schema/PatientFinding'
import { logger } from '@pkg/shared/logger'
import { useQuery } from '@tanstack/react-query'
import { useMatch } from '@tanstack/react-router'
import type { ReactNode } from 'react'

export interface FindingsSelectorProps {
  patientId?: PatientIdType
  selector?: (findings: PatientFindingView[]) => PatientFindingView[]
  children: (findings: PatientFindingView[]) => ReactNode
}

export const FindingsSelector = (opts: FindingsSelectorProps) => {
  const { children, selector = findings => findings } = opts
  const params = useMatch({ strict: false, select: s => s.params })
  const patientId = (opts.patientId ?? params.id) as PatientIdType

  const { data: findings = [] } = useQuery({
    ...patientFindingsQueryOptions(patientId),
    select: selector,
  })

  if (!patientId) {
    logger.warn('Patient ID is required for findings selector')
    return children([])
  }

  return children(findings)
}
